/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        Loader = require("ui/loader/Loader"),
        template = require("connection-templates/chatTab/chatContactsLayout.tmpl"),
        SearchView = require("connection-views/SearchView"),
        ChatContactsLayout = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ChatContactsLayout = Marionette.Layout.extend({
            template: template,
            className: "connection-panel-contact-list",
            regions: {
                "searchRegion": ".contacts-search-region",
                "contactsGroupsRegion": ".contacts-groups-region",
                "contactsUsersRegion": ".contacts-users-region"
            },

            ui: {
                "contactsListContainer": ".contacts-list-container",
                "contactsSearchRegion": ".contacts-search-region"
            },

            initialize: function () {
                this._searchView = new SearchView({placeholder: LE.translator.translate("LEConnection.chat.livePersonChatWidgetSearchAreaText")});
                this._bindEvents();
            },

            _bindEvents: function(){
                this.listenTo(this._searchView, SearchView.TRIGGERING.CHANGE, this._onFilterInputKeyUp);
                this.listenTo(this._searchView, SearchView.TRIGGERING.CLEAR_INPUT, this._onFilterCleared);
            },

            onRender: function () {
                this.searchRegion.show(this._searchView);
                this.setLoader();
                setTimeout(_.bind(this.closeLoader, this), 10000);
            },

            _onFilterInputKeyUp: function (info) {
                this._triggerFilterTermChange(info.searchTerm);
            },

            _onFilterCleared: function(){
                this.trigger("contacts:filter:term:change", {term: ""});
            },

            _triggerFilterTermChange: function (term) {
                this.trigger("contacts:filter:term:change", {term: term});
            },

            setLoader:function(){
                    this._loaderLock = true;
                    if(this.getIsRendered){
                        this._getLoader().render();
                    }else{
                        this.listenTo(this,"render",function(){
                            this._getLoader().render();
                        });
                    }
            },

            closeLoader: function () {
                this._getLoader().close();
            },

            _getLoader:function(){
                if (!this._loader) {
                    this._loader = new Loader({
                        permutation: Loader.PERMUTATION.B,
                        el: this.$el,
                        zIndex:2
                    });
                }
                return this._loader;
            }
        });
    });

    return ChatContactsLayout;
});
